// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"4ab26050","7271":"5a9af4e4","8097":"4ab26050","8705":"7cfcb020"}[chunkId] + ".chunk.css";
};